<template>
    <li class="partial_result_item">
        <a :href="data.link" target="_blank" class="partial_result_img_box">
            <img class="partial_result_img" v-if="data.cover" :src="data.cover" alt="">
            <img v-else class="partial_result_img_icon"
                 :src="data.type == 'word' ? textIcon : data.type == 'music' ? musicIcon : fileIcon  " alt="">

        </a>

        <Tooltip style="max-width: 100%;" max-width="200" :content="data.link"><p class="partial_result_url">{{
            data.link }}</p></Tooltip>

        <div class="partial_result_msg">
            <span class="partial_result_name">{{ data.platformName }}</span>
            <router-link class="monitor_item_btn"
                         :to="data.link ? '/evidenceWeb?url=' + encodeURIComponent(data.link) : '/evidenceWeb' ">取证
            </router-link>
        </div>
    </li>
</template>

<script>
    export default {
        name: "monitorItem",
        data() {
            return {
                textIcon: require('@/assets/text_small_icon.png'),
                musicIcon: require('@/assets/music_small_icon.png'),
                fileIcon: require('@/assets/file_small_icon.png'),
            }
        },
        props: {
            data: {
                type: Object,
                default: {},
            }
        }

    }
</script>

<style scoped lang="less">
    .partial_result_item {
        width: 205px;
        height: 219px;
        box-sizing: border-box;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:4px;
        padding: 10px;
    }

    .partial_result_item .partial_result_img_box {
        width: 185px;
        height: 126px;
        background: #fcfcfc;
        display: flex;

    }

    .partial_result_item .partial_result_img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        display: block;
        object-fit: cover;
    }

    .partial_result_img_box .partial_result_img_icon {
        width: 50px;
        height: 42px;
        display: block;
        align-self: center;
        margin: 0 auto;
    }

    .partial_result_item .partial_result_url {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #666;
        font-size: 12px;
        padding-top: 10px;
        line-height: 17px;
    }

    .partial_result_item .partial_result_msg {
        display: flex;
        padding-top: 5px;
        justify-content: space-between;
        font-size: 14px;
        color: #3A3A3A;
    }

    .partial_result_msg .partial_result_name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 64%;
        line-height: 2;
    }

    .monitor_item_btn {
        width: 64px;
        height: 29px;
        line-height: 29px;
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        text-align: center;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-weight: 400;
    }


    .monitor_item_btn:hover {
        background: rgba(18,18,16,1);
        color:#fff;
        border: 1px solid rgba(18,18,16,1);
    }

    /deep/ .ivu-tooltip-rel {
        display: block;
    }

    /deep/ .ivu-tooltip-inner-with-width {
        word-break: break-all;
    }
</style>